import Vue from 'vue';
export default Vue.extend({
    methods: {
        buildLabels(payload) {
            const labels = [];
            if (payload) {
                return payload.map((item) => item.key);
            }
            return labels;
        },
        buildGraphData(payload) {
            const graphData = [];
            if (payload) {
                return payload.map((item) => item.numberValue);
            }
            return graphData;
        },
    },
});
